import { Moon, Sun } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { THEME_LEVELS, themeAtLevel, themeLevel } from "../lib/theme";

export default function ThemeLevelSlider({ value, onChange, testId = "theme-slider", compact = false, className = "" }) {
  const { t } = useI18n();
  const level = themeLevel(value);
  const selected = THEME_LEVELS[level - 1];
  return <div className={`pc-theme-slider ${compact ? "pc-theme-slider--compact" : ""} ${className}`.trim()}
    data-testid={testId} data-theme-level={level}>
    <div className="pc-theme-slider__control">
      <Sun size={compact ? 14 : 16} aria-hidden="true" />
      <div className="pc-theme-slider__range-wrap">
        <input type="range" min="1" max="5" step="1" value={level}
          aria-label={t("themeBrightness")}
          aria-valuetext={`${t("themeLevel")} ${level}: ${t(selected.labelKey)}`}
          onChange={(event) => onChange(themeAtLevel(event.target.value))} />
        <div className="pc-theme-slider__ticks" aria-hidden="true">
          {THEME_LEVELS.map((row) => <i key={row.value} data-active={row.level <= level ? "true" : "false"} />)}
        </div>
      </div>
      <Moon size={compact ? 14 : 16} aria-hidden="true" />
    </div>
    {!compact && <span className="pc-theme-slider__label">{t("themeLevel")} {level} · {t(selected.labelKey)}</span>}
  </div>;
}
